import type { TranslationMessages } from '../types';

export const campaign_report: TranslationMessages = {
      title: 'Báo cáo chiến dịch',
      loading: 'Đang tải báo cáo chiến dịch...',
      load_error: 'Không thể tải báo cáo',
      back_to_campaigns: 'Quay lại chiến dịch',
      revenue_metrics: 'Chỉ số doanh thu',
      total_revenue: 'Tổng doanh thu',
      category_revenue: 'Doanh thu danh mục',
      average_order_value: 'Giá trị đơn hàng trung bình',
      average_daily_revenue: 'Doanh thu trung bình hàng ngày',
      average_daily_campaign_revenue:
        'Doanh thu trung bình hàng ngày (chiến dịch)',
      campaign_period_total: 'Tổng thời gian chiến dịch',
      campaign_category_sales: 'Bán hàng danh mục chiến dịch',
      aov_during_campaign: 'AOV trong chiến dịch',
      daily_average: 'Trung bình hàng ngày',
      daily_average_all_orders: 'Trung bình cho tất cả đơn hàng',
      daily_average_campaign_orders: 'Trung bình cho đơn hàng chiến dịch',
      product_performance: 'Hiệu suất sản phẩm',
      total_items_sold: 'Tổng số sản phẩm đã bán',
      campaign_items_sold: 'Sản phẩm chiến dịch đã bán',
      daily_sell_through: 'Tỷ lệ bán hàng hàng ngày',
      all_products: 'Tất cả sản phẩm',
      campaign_category_products: 'Danh mục/sản phẩm chiến dịch',
      average_units_per_day: 'Số đơn vị trung bình mỗi ngày',
      top_20_products: 'Top 20% Sản phẩm',
      top_products: 'Top Sản phẩm',
      units: 'đơn vị',
      customer_metrics: 'Chỉ số khách hàng',
      total_customers: 'Tổng Khách Hàng',
      repeat_purchase_rate: 'Tỷ Lệ Mua Lại',
      new_customers: 'Khách Hàng Mới',
      unique_customers: 'khách hàng duy nhất',
      repeat_customers: 'khách hàng mua lại',
      of_total: 'của tổng',
      target_vs_actual: 'Mục Tiêu vs Thực Tế',
      daily_breakdown: 'Phân Tích Hàng Ngày',
      orders: 'đơn hàng',
      of_target: 'của mục tiêu',
      target: 'Mục Tiêu',
      campaign_duration: 'Thời Gian Chiến Dịch',
      days_remaining: 'Số Ngày Còn Lại',
      days: 'ngày',
      remaining: 'còn lại',
      ended: 'Đã Kết Thúc',
      target_avg_per_30_days: 'Mục Tiêu TB mỗi 30 Ngày',
      target_avg_per_day: 'Mục Tiêu TB mỗi Ngày',
    };
